module.exports = __webpack_public_path__ + "d0a7256c2062c34082253ef9c181dafc.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/banner_frame.png
// module id = 181
// module chunks = 0